import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchAssessments } from "@workspace/assessment/src/store/assessments/action";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from "reactstrap";
import "./AssessmentTab.scss";
import { format } from "date-fns";

function AssessmentTab() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const assessmentsData = useSelector((state) => state?.AssessmentsReducer?.assessments);

  useEffect(() => {
    if (assessmentsData) {
      dispatch(fetchAssessments());
    }
  }, []);

  return (
    <div>
      <Row className="mb-3">
        <div className="d-flex flex-row align-items-baseline justify-content-between">
          <div className="mb-3">
            <span className="fs-5 fw-semibold">Assessments</span>
          </div>
          <div className="d-flex flex-row align-items-baseline gap-2">
            <div className="search-box">
              <input
                placeholder="Search.."
                type="text"
                className="form-control"
                style={{ width: "300px", borderColor: "#F7F8FC" }}
              />
              <span className="search-icon mdi mdi-magnify"></span>
            </div>
            <Dropdown
              isOpen={dropdownOpen}
              toggle={() => setDropdownOpen(!dropdownOpen)}
              direction="down"
            >
              <DropdownToggle
                caret
                style={{
                  backgroundColor: "#3F88E4",
                  color: "#fff",
                  borderRadius: "8px",
                }}
              >
                + New
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={() => navigate("/assessment/create")}>
                  New Assessment
                </DropdownItem>
                <DropdownItem
                  onClick={() => navigate("/assessment/question-bank")}
                >
                  New Question
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
            <Button
              style={{
                backgroundColor: "#fff",
                border: "1px solid #C3D3E2",
                borderRadius: "8px",
              }}
              className="d-flex flex-row align-items-baseline gap-1"
            >
              <span className="mdi mdi-filter-variant"></span>
              <span>Filter</span>
            </Button>
          </div>
        </div>
      </Row>
      <Row>
        <Col lg={12}>
          {assessmentsData?.length > 0 ? (
            assessmentsData?.map((assessment, index) => {
              return (
                <Card
                  key={index}
                  style={{
                    backgroundColor: "#F9FCFF",
                    border: "1px solid #7AC7FF",
                    borderRadius: "16px",
                  }}
                >
                  <CardBody>
                    <div>
                      <div className="d-flex flex-column gap-2">
                        <div className="d-flex flex-row align-items-baseline justify-content-between">
                          <div className="d-flex flex-row align-items-baseline gap-3">
                            <div style={{ fontSize: "18px" }}>
                              {assessment.assessmentName}
                            </div>
                            <span
                              className="translate-middle bg-success"
                              style={{
                                width: "10px",
                                height: "10px",
                                borderRadius: "50%",
                              }}
                            ></span>
                            <div className="d-flex flex-row gap-1 align-items-center">
                              <span
                                className="mdi mdi-calendar-blank-outline"
                                style={{
                                  color: "#C1C1C1",
                                  fontSize: "16px",
                                }}
                              ></span>
                              <span>Dec 10, 2024 - 10:00 AM</span>
                            </div>
                          </div>

                          <span className="mdi mdi-dots-horizontal cursor-pointer"></span>
                        </div>

                        <div
                          className="d-flex flex-row gap-2"
                          style={{ color: "#7F7F7F" }}
                        >
                          <span>1 Candidate Taking</span>
                          <span>|</span>
                          <span>10 Completed</span>
                          <span>|</span>
                          <span>
                            Expire on{" "}
                            {format(
                              new Date(assessment?.expiryDate),
                              "dd MMMM yyyy"
                            )}
                          </span>
                        </div>

                        <div className="d-flex align-items-baseline flex-row justify-content-between">
                          <div className="d-flex flex-row align-items-baseline gap-2">
                            <div
                              className="d-flex flex-row align-items-baseline gap-1"
                              style={{
                                backgroundColor: "#FFFFFF",
                                border: "1px solid #EAECF0",
                                borderRadius: "3px",
                                padding: "6px",
                              }}
                            >
                              <span
                                className="mdi mdi-file-document-outline"
                                style={{ color: "#3F88E4" }}
                              ></span>
                              <span
                                style={{ color: "#3F88E4" }}
                                className="fw-semibold"
                              >
                                {assessment?.testQuestions?.length}
                              </span>
                              <span>Questions</span>
                            </div>
                            <div
                              className="d-flex flex-row align-items-baseline gap-1"
                              style={{
                                backgroundColor: "#FFFFFF",
                                border: "1px solid #EAECF0",
                                borderRadius: "3px",
                                padding: "6px",
                              }}
                            >
                              <span
                                className="mdi mdi-account-multiple-outline"
                                style={{ color: "#3F88E4" }}
                              ></span>
                              <span>
                                suganth@gmail.com, jovyn@gmail.com,
                                mary@gmail.com
                              </span>
                              <span
                                className="fw-semibold"
                                style={{ color: "#3F88E4" }}
                              >
                                +23
                              </span>
                            </div>
                            <div
                              className="d-flex flex-row align-items-baseline gap-1"
                              style={{
                                backgroundColor: "#FFFFFF",
                                border: "1px solid #EAECF0",
                                borderRadius: "3px",
                                padding: "6px",
                              }}
                            >
                              <span
                                className="mdi mdi-file-document-outline"
                                style={{ color: "#3F88E4" }}
                              ></span>
                              <span
                                className="fw-semibold"
                                style={{ color: "#3F88E4" }}
                              >
                                10
                              </span>
                              <span>Reports</span>
                            </div>
                            <div
                              className="d-flex flex-row align-items-baseline gap-1"
                              style={{
                                backgroundColor: "#FFFFFF",
                                border: "1px solid #EAECF0",
                                borderRadius: "3px",
                                padding: "6px",
                              }}
                            >
                              <span
                                className="mdi mdi-timer-outline"
                                style={{ color: "#3F88E4" }}
                              ></span>
                              <span
                                style={{ color: "#3F88E4" }}
                                className="fw-semibold"
                              >
                                {assessment.durationHr}:{assessment.durationMin}
                              </span>
                              <span>min</span>
                            </div>
                          </div>
                          <div className="d-flex align-items-center flex-row gap-1">
                            <Button className="assessment-row-btns">
                              <span className="mdi mdi-cog-outline"></span>
                            </Button>
                            <Button className="assessment-row-btns">
                              <span className="mdi mdi-link"></span>
                            </Button>
                            <Button className="assessment-row-btns">
                              <span className="mdi mdi-account-plus-outline"></span>
                            </Button>
                            <Button className="assessment-row-btns">
                              <span className="mdi mdi-download-box-outline"></span>
                            </Button>
                            <span
                              style={{
                                padding: "10px",
                              }}
                            ></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              );
            })
          ) : (
            <div>No assessments created.</div>
          )}
        </Col>
      </Row>
    </div>
  );
}

export default AssessmentTab;
